import styled from "@emotion/styled";
import { ReactComponent as Back } from "@src/assets/icons/arrowBackWithTail.svg";

const BackIcon = styled(Back)`
  min-width: 16px;
  max-width: 16px;
  height: 18px;
  transform: rotate(180deg);
  margin: 0 4px;
`;

export default BackIcon;
